<template>
  <div class="seven_section">
    <h1>开发文档</h1>
    <div class="doc_wrapper">
      <div class="doc_item">
        <h3>PC端</h3>
        <hr />
        <router-link
          class="doc_content"
          v-for="item in docsData.pcDocs"
          :key="item.fileId"
          :to="`/api/pc/${item.nameEn}`"
        >
          {{ item.name }}
        </router-link>
      </div>

      <div class="doc_item">
        <h3>Android平台</h3>
        <hr />

        <router-link
          class="doc_content"
          v-for="item in docsData.androidDocs"
          :key="item.fileId"
          :to="`/api/Android/${item.nameEn}`"
        >
          {{ item.name }}
        </router-link>
      </div>

      <div class="doc_item">
        <h3>iOS平台</h3>
        <hr />
        <router-link
          class="doc_content"
          v-for="item in docsData.iosDocs"
          :key="item.fileId"
          :to="`/api/IOS/${item.nameEn}`"
        >
          {{ item.name }}
        </router-link>
      </div>
      <div class="doc_item">
        <h3>WEB服务</h3>
        <hr />
        <router-link
          class="doc_content"
          v-for="item in docsData.smDocs"
          :key="item.fileId"
          :to="`/api/web/${item.nameEn}`"
        >
          {{ item.name }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(['docsData'])
  },
};
</script>

<style lang="scss" scoped>
.seven_section {
  width: 100%;
  height: 660px;
  background: linear-gradient(90deg, #28314a, #191e2e);
  h1 {
    padding: 70px 0px;
    text-align: center;
    font-size: 28px;
    font-weight: 400;
    color: #ffffff;
  }
  .doc_wrapper {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .doc_item {
      box-sizing: border-box;
      width: 22%;
      height: 350px;
      background: linear-gradient(to top right, #bfcbde, #f6f9ff);
      padding: 35px 30px;
      h3 {
        font-size: 18px;
        font-weight: 300;
        color: #080a25;
      }
      hr {
        text-align: left;
        width: 20px;
        height: 2px;
        background: #465073;
        margin: 11px 0 20px 0px;
        transition: all 0.25s ease-in;
      }
      .doc_content {
        display: inline-block;
        width: 100%;
        font-size: 12px;
        font-weight: 300;
        color: #080a25;
        text-decoration: none;
        margin-top: 10px;
      }
      &:hover {
        background: #fff;
        hr {
          width: 80px;
          transition: all 0.25s ease-in;
        }
      }
    }
  }
}
hr {
  border: 0;
  border-top: 1px solid #eee;
}
</style>